import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorToast, successToast } from '../../util/Toast/toast'
import { addcleanerReportCategory, editcleanerReportCategory } from '../../redux/slices/cleanerReportSlice'
import { cleanerReportCategorySchema } from '../../util/validationSchema'

const AddEditCleanerReportCategory = ({ editData, cleanerReportCategoryID, toggle, setIsRefresh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const {
    handleSubmit,
    control,
    trigger,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(cleanerReportCategorySchema),
    defaultValues: {
      category: cleanerReportCategoryID ? editData?.category || '' : ''
    }
  })

  const handleSuccess = (message) => {
    toggle()
    changeLoader(false)
    setIsRefresh(true)
    successToast(message || 'Success!')
  }

  const handleError = (message) => {
    errorToast(message)
    changeLoader(false)
  }

  const onSubmit = (data) => {
    setIsRefresh(false)
    changeLoader(true)

    if (cleanerReportCategoryID) {
      const payloadData = {
        data,
        cleanerReportCategoryID: cleanerReportCategoryID
      }


      // Uncomment and implement edit functionality here if needed
      dispatch(editcleanerReportCategory(payloadData))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            handleSuccess(payload?.data?.status_message)
          } else {
            handleError(payload?.data?.status_message || error?.message)
          }
        })
        .catch((err) => {
          console.error('Error:', err)
          changeLoader(false)
        })
    } else {
      dispatch(addcleanerReportCategory(data))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            handleSuccess(payload?.data?.status_message)
            reset()
          } else {
            handleError(payload?.data?.status_message || error?.message)
          }
        })
        .catch((err) => {
          console.error('Error:', err)
          changeLoader(false)
        })
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Category<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="category"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Category"
                              onChange={(e) => {
                                onChange(e.target.value)
                                trigger('category')
                              }}
                            />
                            {errors.category && <small className="text-danger">{errors.category.message}</small>}
                          </>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={toggle}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  {cleanerReportCategoryID ? 'Update' : 'Create'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddEditCleanerReportCategory
